var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7525 0C14.9951 0 16.0025 1.00736 16.0025 2.25L16.002 3.003L16.7525 3.00358C18.5469 3.00533 20.0011 4.45877 20.0038 6.25244L20.0071 12.2497C20.009 13.4918 19.0021 14.5002 17.7591 14.5009L16 14.5V15.75C16 16.9926 14.9926 18 13.75 18H6.25C5.00736 18 4 16.9926 4 15.75L4.00091 14.5L2.25 14.5001C1.00736 14.5001 0 13.4927 0 12.2501V6.25358C0 4.45865 1.45507 3.00358 3.25 3.00358L3.999 3.003L4 2.25C4 1.00736 5.00736 0 6.25 0H13.7525ZM13.75 10.5H6.25C5.83579 10.5 5.5 10.8358 5.5 11.25V15.75C5.5 16.1642 5.83579 16.5 6.25 16.5H13.75C14.1642 16.5 14.5 16.1642 14.5 15.75V11.25C14.5 10.8358 14.1642 10.5 13.75 10.5ZM16.7518 4.50358H3.25C2.2835 4.50358 1.5 5.28708 1.5 6.25358V12.2501C1.5 12.6643 1.83579 13.0001 2.25 13.0001L4 13V11.25C4 10.0074 5.00736 9 6.25 9H13.75C14.9926 9 16 10.0074 16 11.25L16.0009 13.0001L17.7827 13.0005C18.1855 12.9874 18.5077 12.6567 18.5071 12.2512L18.5038 6.25398C18.5024 5.28801 17.7185 4.50452 16.7518 4.50358ZM13.7525 1.5H6.25C5.83579 1.5 5.5 1.83579 5.5 2.25L5.499 3.003H14.502L14.5025 2.25C14.5025 1.83579 14.1667 1.5 13.7525 1.5Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.a38f04f2d8e4b42ef44cf2e6b19a445e.svg";
export { ForwardRef as ReactComponent };